module.exports = __webpack_public_path__ + "img/sla.7ea21b7a.jpg";